export const BoxColorVariableNames = {
  'wst-box-primary-background-color': 'wst-box-primary-background-color',
  'wst-box-primary-border-left-color': 'wst-box-primary-border-left-color',
  'wst-box-primary-border-right-color': 'wst-box-primary-border-right-color',
  'wst-box-primary-border-top-color': 'wst-box-primary-border-top-color',
  'wst-box-primary-border-bottom-color': 'wst-box-primary-border-bottom-color',
  'wst-box-secondary-background-color': 'wst-box-secondary-background-color',
  'wst-box-secondary-border-left-color': 'wst-box-secondary-border-left-color',
  'wst-box-secondary-border-right-color': 'wst-box-secondary-border-right-color',
  'wst-box-secondary-border-top-color': 'wst-box-secondary-border-top-color',
  'wst-box-secondary-border-bottom-color': 'wst-box-secondary-border-bottom-color'
};
export const BoxVariableNames = {
  ...BoxColorVariableNames,
  'wst-box-primary-border-left-width': 'wst-box-primary-border-left-width',
  'wst-box-primary-border-right-width': 'wst-box-primary-border-right-width',
  'wst-box-primary-border-top-width': 'wst-box-primary-border-top-width',
  'wst-box-primary-border-bottom-width': 'wst-box-primary-border-bottom-width',
  'wst-box-primary-border-left-style': 'wst-box-primary-border-left-style',
  'wst-box-primary-border-right-style': 'wst-box-primary-border-right-style',
  'wst-box-primary-border-top-style': 'wst-box-primary-border-top-style',
  'wst-box-primary-border-bottom-style': 'wst-box-primary-border-bottom-style',
  'wst-box-primary-border-top-left-radius': 'wst-box-primary-border-top-left-radius',
  'wst-box-primary-border-top-right-radius': 'wst-box-primary-border-top-right-radius',
  'wst-box-primary-border-bottom-left-radius': 'wst-box-primary-border-bottom-left-radius',
  'wst-box-primary-border-bottom-right-radius': 'wst-box-primary-border-bottom-right-radius',
  'wst-box-primary-box-shadow': 'wst-box-primary-box-shadow',
  'wst-box-secondary-border-left-width': 'wst-box-secondary-border-left-width',
  'wst-box-secondary-border-right-width': 'wst-box-secondary-border-right-width',
  'wst-box-secondary-border-top-width': 'wst-box-secondary-border-top-width',
  'wst-box-secondary-border-bottom-width': 'wst-box-secondary-border-bottom-width',
  'wst-box-secondary-border-left-style': 'wst-box-secondary-border-left-style',
  'wst-box-secondary-border-right-style': 'wst-box-secondary-border-right-style',
  'wst-box-secondary-border-top-style': 'wst-box-secondary-border-top-style',
  'wst-box-secondary-border-bottom-style': 'wst-box-secondary-border-bottom-style',
  'wst-box-secondary-border-top-left-radius': 'wst-box-secondary-border-top-left-radius',
  'wst-box-secondary-border-top-right-radius': 'wst-box-secondary-border-top-right-radius',
  'wst-box-secondary-border-bottom-left-radius': 'wst-box-secondary-border-bottom-left-radius',
  'wst-box-secondary-border-bottom-right-radius': 'wst-box-secondary-border-bottom-right-radius',
  'wst-box-secondary-padding-bottom': 'wst-box-secondary-padding-bottom',
  'wst-box-secondary-padding-top': 'wst-box-secondary-padding-top',
  'wst-box-secondary-padding-left': 'wst-box-secondary-padding-left',
  'wst-box-secondary-padding-right': 'wst-box-secondary-padding-right',
  'wst-box-secondary-box-shadow': 'wst-box-secondary-box-shadow'
};
//# sourceMappingURL=box.js.map